module.exports = __webpack_public_path__ + "static/img/guide_3_1_1.c66f8d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guide_3_1_1.jpg
// module id = Q8RN
// module chunks = 1